import React, { useState } from "react";
import { getImageFromAssetFolder } from "../../../utils/assets";
import { Link, useLocation } from "react-router-dom";
import { LogOut, Menu, X } from "lucide-react";
import { logoutUser } from "../../../utils/auth";

const SideMenu = ({ user }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <>
      {/* Mobile Top Header Bar */}
      <div className="lg:hidden fixed top-0 left-0 right-0 h-14 bg-primary px-4 flex items-center justify-between z-40 shadow-md">
        <img
          src={getImageFromAssetFolder("/logo_text_white.png")}
          className="w-24 object-contain"
          alt="Logo"
        />
        <button
          onClick={toggleMenu}
          className="text-white p-1.5 focus:outline-none hover:bg-white/10 rounded-lg transition"
          aria-label="Toggle Menu"
        >
          {isOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile Backdrop Overlay */}
      {isOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black/50 backdrop-blur-sm z-40 transition-opacity"
          onClick={closeMenu}
        />
      )}

      {/* Sidebar Navigation Panel */}
      <aside
        className={`fixed left-0 top-0 h-screen w-64 bg-primary shadow-md flex flex-col z-50 transform lg:transform-none lg:opacity-100 transition-all duration-300 ease-in-out ${
          isOpen
            ? "translate-x-0 opacity-100"
            : "-translate-x-full lg:translate-x-0"
        }`}
      >
        {/* Sidebar Header Section with Close Toggle on Mobile */}
        <div className="px-8 py-6 lg:py-8 flex items-center justify-between">
          <img
            src={getImageFromAssetFolder("/logo_text_white.png")}
            className="w-28"
            alt="Logo"
          />
          <button
            onClick={closeMenu}
            className="lg:hidden text-white/80 p-1 hover:text-white hover:bg-white/10 rounded-lg"
          >
            <X size={20} />
          </button>
        </div>

        {/* Navigation Section */}
        <nav className="flex-1 px-6 lg:px-8">
          <ul className="space-y-2 lg:space-y-4">
            <li>
              <Link
                to="/expert-view"
                onClick={closeMenu}
                className={`flex items-center px-3 py-2 rounded-lg text-sm text-white transition hover:bg-white/10 ${
                  location.pathname === "/expert-view" ||
                  location.pathname === "/expert-view/"
                    ? "bg-white/15 font-semibold underline decoration-2 underline-offset-4"
                    : "hover:underline"
                }`}
              >
                Dashboard
              </Link>
            </li>

            <li>
              <Link
                to="/expert-view/learning-and-development"
                onClick={closeMenu}
                className={`flex items-center px-3 py-2 rounded-lg text-sm text-white transition hover:bg-white/10 ${
                  location.pathname.includes("/learning-and-development")
                    ? "bg-white/15 font-semibold underline decoration-2 underline-offset-4"
                    : "hover:underline"
                }`}
              >
                Learning & Development
              </Link>
            </li>
          </ul>
        </nav>

        {/* User Account / Footer Area */}
        <div className="border-t border-white/20 p-4 bg-primaryDark/10">
          <div className="flex items-center justify-between">
            <div className="flex items-center min-w-0">
              <img
                className="h-9 w-9 lg:h-10 lg:w-10 rounded-full object-cover mr-3 p-[1px] bg-white flex-shrink-0"
                src={
                  user?.profileImageUrl ||
                  getImageFromAssetFolder("short_logo.png")
                }
                alt={user?.name || "User profile"}
              />
              <p className="font-semibold text-sm lg:text-base text-white truncate">
                {user?.name || "Expert"}
              </p>
            </div>

            <button
              onClick={() => {
                logoutUser();
                window.location.reload();
              }}
              className="cursor-pointer p-1.5 hover:bg-white/10 rounded-lg transition"
              title="Logout"
            >
              <LogOut size={18} color="white" />
            </button>
          </div>
        </div>
      </aside>
    </>
  );
};

export default SideMenu;
